// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 4H0V20H17V15.7232L24 19.7232V4.23382L17 8.43382V4ZM10 10H4V8H10V10Z"}}]};

const VideoCamera1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-1-filled',
    ref,
    icon: element,
  },
));

VideoCamera1FilledIcon.displayName = 'VideoCamera1FilledIcon';

export default VideoCamera1FilledIcon;
